<template>
  <van-dialog v-model="show" title="" :showConfirmButton="false" :close-on-click-overlay="true" @close="$emit('close')">
    <div class="dialog_title">
      <div></div>
      <span>{{value.relName || value.name || ''}}</span>
      <i class="iconfont icon-icon-close" @click="$emit('close')"></i>
    </div>
    <div class="dialog_content">
      <div class="content_list" v-for="(item,index) of value.occupies" :key="index">
        <div>
          <i class="iconfont icon-wuxupailie"></i>
          <span>{{item.businessTypeText}}</span>
        </div>
        <div>
          <i class="iconfont icon-a-shijiancopy"></i>
          <span>{{item.occupyStartDate | dateFormat}} ~ {{item.occupyEndDate | dateFormat}}</span>
        </div>
        <div>
          <i class="iconfont icon-icon-myhomework-svg"></i>
          <span>
            <span v-if="item.reason" v-html="item.reason"></span>
            <span v-else>无</span>
            ({{item.businessTypeText}})</span>
        </div>
        <div>
          <i class="iconfont icon-icon-gly"></i>
          <span>{{item.contacts|| '无'}}</span>
        </div>
        <div>
          <i class="iconfont icon-a-icon-phone"></i>
          <span>{{item.phone|| '无'}}</span>
        </div>
        <div class="dialog_btn">
          <div @click="addValue(item)">新增</div>
          <div @click="editValue(item)" v-if="item.businessTypeValue=='3'">编辑</div>
          <div @click="releaseOccupation(item)" v-if="item.businessTypeValue=='3' || item.businessTypeValue=='4'">解除占用</div>
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>

export default {
  name: "DsfOccupyDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null
    }
  },
  filters: {
    dateFormat(val) {
      if (val && val.length > 16) {
        return val.substring(11, 16)
      } else {
        return val
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    //   新增
    addValue(val) {
      let value = {
        startDate: this.value.startDate,
        endDate: this.value.endDate,
        relName: this.value.relName,
        name: this.value.name,
        id: val.resourceId,
        phone: '',
        reason: '',
        contacts: '',
      }
      this.$emit('addValue', value)
    },
    // 编辑
    editValue(val) {
      let value = {
        startDate: this.value.startDate,
        endDate: this.value.endDate,
        relName: this.value.relName,
        name: this.value.name,
        id: val.resourceId,
        phone: val.phone,
        reason: val.reason,
        contacts: val.contacts,
        relid: val.relid,
        occupyId: val.occupyId
      }
      this.$emit('editValue', value)
    },
    // 解除占用
    releaseOccupation(val) {
      dsf.layer.confirm("确定要解除占用吗？").then(() => {
        this.$http
          .post("/resource/occupy/relieveOccupy", {
            occupyId: val.occupyId,
          })
          .done((res) => {
            if (res.success) {
              dsf.layer.message("解除占用成功!");
              this.$emit("releaseOccupation");
            }
          });
      })

    }
  },
  created() {
  }
}
</script>

<style>
</style>